import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    destroy: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/portal/groups/${url.id}`, config),
    fetch: (config: AxiosRequestConfig) => api.get(`/portal/groups`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/portal/groups/${url.id}`, config),
    store: (data: object, config: AxiosRequestConfig) =>
        api.post(`/portal/groups`, data, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/portal/groups/${url.id}`, data, config),
    patch: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.patch(`/portal/groups/${url.id}`, data, config),
};

export default requests;
